import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-object-allocation-register',
  templateUrl: './object-allocation-register.component.html',
  styleUrls: ['./object-allocation-register.component.css']
})
export class ObjectAllocationRegisterComponent implements OnInit {

  singleObjectAllocationRegisterData: any = []
  objectTemplateId = ""
  page: number = 0;
  count: number = 0;
  tableSize: number = 10;
  recordsPerPage: any = 10
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid: any
  objectAllocationRegisterList: any = []
  isLoading: any = false
  formSubmit: any = false
  form: any | FormGroup
  objectInfoList: any = []
  objectInfoListByTemplateNameAndLocation: any = []
  usersList: any = []
  objectStatus: any = "ALL"


  statusListInfo: any = [
    { key: 'ALL', value: 'All' },
    { key: 'REQUESTED', value: 'Requested' },
    { key: 'VERIFIED', value: 'Verified' },
    { key: 'APPROVED', value: 'Approved' },
    { key: 'ISSUED', value: 'Issued' },
    { key: 'RECEIVED', value: 'Received' },
    { key: 'REJECTED', value: 'Rejected' },
    { key: 'DEPLOYED', value: 'Deployed' },
    { key: 'RETURNED', value: 'Returned' },
    { key: 'RETURN_RECEIVED', value: 'Return Received' },
    // { key: 'PARTIALLY_APPROVED', value: 'Partially Approved' },
    { key: 'PARTIALLY_ISSUED', value: 'Partially Issued' },
    { key: 'PARTIALLY_DEPLOYED', value: 'Partially Deployed' }
  ];


  statusList: any = [
    "ALL", "REQUESTED", "VERIFIED", "APPROVED", "ISSUED", "RECEIVED", "REJECTED", "DEPLOYED", "RETURNED", "RETURN_RECEIVED"
  ]

  updateStatusList: any = [
    "REQUESTED", "VERIFIED", "ISSUED", "APPROVED", "RECEIVED", "REJECTED", "DEPLOYED", "RETURNED", "RETURN_RECEIVED"
  ]

  searchFilter: any = "";
  recordId: any = "";
  recordName: any = "";
  isStatusUpdate: any = false
  isApproveUpdate: any = false
  isReject: any = false
  isStatusSubmited: any = false
  isIssued: any = false
  issueStatus: any = "";
  remarks: any = "";
  approvedQuantity: any = "";



  issuedSelectedList: any = [];
  issuedSelectedListWithDetail: any = [];
  issuedDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectInfoId',
    textField: 'nameAndAvailableQty',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    enableCheckAll: false,
  };
  locationList: any = [];
  userCred: any;
  objectTemplateList: any = [];
  uomData: any;


  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false,
    isVerify: false,
    isApprove: false,
    isIssue: false,
    isAttach: false,
    isRemove: false
  }
  issueSelection: boolean = true;
  isRequestedUOM: boolean = false;
  private destroy$ = new Subject<void>();
  locationFilterList: any = [];
  userLocations: any = [];


  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'))
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);

    this.actionControls = this.generic_service.checkActionControls(
      window.location.href.split('/').filter(Boolean).pop()?.toLowerCase() || ''
    );

    console.log(this.actionControls)
    this.getAllLocation()


    this.form = this.fb.group({
      description: [''],
      objectTemplateName: ['', [Validators.required]],
      location: ['', [Validators.required]],
      requestedQuantity: ['', [Validators.required]],
      requestedUOM: ['']
    })

    this.form.patchValue({
      issuedByUserName: sessionStorage.getItem('userName'),
      issuedByUserId: sessionStorage.getItem('userId')
    })
    // this.getAllObjectAllocationRegister()

    this.getAllObjectInfo()
    this.getUsersWithoutCustomers()
    this.getAllObjectTemplate()
    this.getAllUomMaster()


    this.form.get('objectTemplateName')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedZone: any) => {
        const selectedTemplate = this.objectTemplateList.find(
          (t: any) => t.name === selectedZone
        );
        console.log(selectedTemplate)

        this.isRequestedUOM = !!selectedTemplate?.quantity;
        if (!this.isRequestedUOM) {
          this.form.patchValue(
            { requestedUOM: '' }
          );
        }
      });
  }


  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        console.log(res)
        this.uomData = res.response

      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllObjectTemplate() {
    this.generic_service.getAllObjectTemplate().subscribe(
      (response: any) => {
        this.objectTemplateList = response.response
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  // getAllLocation(){
  //   this.generic_service.getAllLocation().subscribe(
  //     (res:any)=> {
  //       this.locationList = res.response


  //     },
  //     (err:any)=>{
  //       console.log(err)
  //     }
  //   )
  // }


  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        this.locationList = res.response

        this.locationFilterList = (this.locationList?.filter((location: any) =>
          this.userCred?.locations?.includes(location.locationId)
        )) || [];
        console.log(this.locationFilterList)

        this.userLocations = this.locationFilterList.map((item: any) => item.zone);
        console.log(this.userLocations)
        this.getAllObjectAllocationRegisterWithPagination(0, 10)


      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        console.log(res);
        this.usersList = res.response;
      }
    )
  }

  userSelected(event: any) {
    console.log(event.target.value)

    for (let list of this.usersList) {
      if (list.userId == event.target.value) {
        this.form.patchValue({
          issuedToUserName: list.userName
        })
        return
      }
    }
  }

  assetSelected(event: any) {
    console.log(event.target.value)

    for (let list of this.objectInfoList) {
      if (list.objectInfoId == event.target.value) {
        this.form.patchValue({
          objectSerialNo: list.serialNumber,
          givenName: list.givenName
        })
        return
      }
    }
  }

  getAllObjectInfo() {
    this.generic_service.getAllObjectInfo().subscribe(
      (response: any) => {
        console.log(response);
        this.objectInfoList = response.response
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page;
    this.first = event.first;
    this.tableSize = event.rows;

    if (this.searchFilter != "") {
      this.getAllObjectAllocationRegistersByWildSearchWithPagination(this.page, this.recordsPerPage, this.searchFilter)
    } else if (this.objectStatus != "ALL") {
      this.getObjectAllocationRegisterByStatusWithPagination(this.page, this.recordsPerPage, this.objectStatus)
    } else {
      this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)
    }
  }

  getObjectAllocationRegisterById(objectAllocationRegisterId: any) {
    this.issueSelection = true
    this.singleObjectAllocationRegisterData = []
    this.issuedSelectedListWithDetail = []
    this.issuedSelectedList = []
    this.isApproveUpdate = false
    this.remarks = ""
    this.approvedQuantity = ""
    this.isReject = false
    this.isIssued = false
    this.generic_service.getObjectAllocationRegisterById(objectAllocationRegisterId).subscribe(
      (response: any) => {
        console.log(response);
        this.singleObjectAllocationRegisterData = []
        this.singleObjectAllocationRegisterData.push(response.response)
        if (response.response.objectTemplateName && response.response.location) {
          this.getObjectInfoByTemplateNameAndLocationAndAvailable(response.response.objectTemplateName, response.response.location, true)
        }
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getObjectInfoByTemplateNameAndLocation(name: any, location: any) {
    this.generic_service
      .getObjectInfoByTemplateNameAndLocation(name, location)
      .subscribe(
        (response: any) => {
          console.log(response);

          const bulkObjects = this.singleObjectAllocationRegisterData?.bulkObjects || [];

          // Create a Set of existing objectIds for fast lookup
          const existingObjectIds = new Set(
            bulkObjects.map((item: any) => item.objectId)
          );

          // Filter response to exclude already allocated objects
          this.objectInfoListByTemplateNameAndLocation =
            response.response.filter(
              (item: any) => !existingObjectIds.has(item.objectInfoId)
            );
        },
        (error: any) => {
          console.log(error);
        }
      );
  }


  getObjectInfoByTemplateNameAndLocationAndAvailable(name: string, location: string, available: boolean) {

    let body: any = {
      "version": 0,
      "isActive": true,
      "description": "",
      "name": name,
      "location": location,
      "available": available,
      "cid": this.cid
    }
    this.generic_service
      .getObjectInfoByTemplateNameAndLocationAndAvailable(body)
      .subscribe({
        next: (response: any) => {
          console.log(response);

          const items = response?.response ?? [];

          const showQty =
            !!this.singleObjectAllocationRegisterData?.[0]?.qty;

          this.objectInfoListByTemplateNameAndLocation = items
            .sort((a: any, b: any) => (a.availableQty ?? 0) - (b.availableQty ?? 0))
            .map((item: any) => ({
              ...item,
              nameAndAvailableQty: showQty
                ? `${item.givenName} (${item.availableQty})`
                : item.givenName
            }));
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }



  getObjectInfoByTemplateNameAndLocationAndAvailable1(name: any, location: any, available: boolean) {

    let body: any = {
      "version": 0,
      "isActive": true,
      "description": "",
      "name": name,
      "location": location,
      "available": available,
      "cid": this.cid
    }
    this.generic_service.getObjectInfoByTemplateNameAndLocationAndAvailable(body).subscribe(
      (response: any) => {
        console.log(response);
        this.issueSelection = true
        this.objectInfoListByTemplateNameAndLocation = []


        const items = response?.response ?? [];

        if (this.singleObjectAllocationRegisterData[0].qty) {
          this.objectInfoListByTemplateNameAndLocation = items.map((item: any) => ({
            ...item,
            nameAndAvailableQty: `${item.givenName} (${item.availableQty})`
          }));
        } else {

          this.objectInfoListByTemplateNameAndLocation = items.map((item: any) => ({
            ...item,
            nameAndAvailableQty: `${item.givenName}`
          }));

        }




      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  // statusChange(){
  //   this.searchFilter = ""
  //   if(this.objectStatus == "ALL"){
  //     this.getAllObjectAllocationRegisterWithPagination(this.page,this.recordsPerPage)
  //   }else{
  //     this.getAllObjectAllocationRegisterWithPagination(this.page,this.recordsPerPage)
  //   }
  // }

  getObjectAllocationRegisterByStatus(status: any) {
    this.generic_service.getObjectAllocationRegisterByStatus(status).subscribe(
      (response: any) => {
        console.log(response);
        this.objectAllocationRegisterList = response.response
        this.count = response.response.length
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getObjectAllocationRegisterByStatusWithPagination(pageNumber: any, recordsPerPage: any, status: any) {

    if (status == "ALL") {
      this.getAllObjectAllocationRegisterWithPagination(0, 10)
      return
    }

    const body: any = {
      "location": this.userLocations || [],
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage,
      "wildSearch": "",
      "userId": this.userCred.userId,
      "status": status,
      "cid": this.cid
    }

    this.isLoading = true
    this.generic_service.getObjectAllocationRegisterByStatusWithPagination(body).subscribe(
      (response: any) => {
        this.objectAllocationRegisterList = response.response.objectAllocationRegisterList
        this.count = response.response.totalRecords
        this.isLoading = false
      },
      (error: any) => {
        this.isLoading = false
        console.log(error)
      }
    )
  }

  getAllObjectAllocationRegistersByWildSearchWithPagination(pageNumber: any, recordsPerPage: any, wildSearch: any) {

    const body: any = {
      "location": this.userLocations || [],
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage,
      "wildSearch": wildSearch,
      "userId": this.userCred.userId,
      "status": "REQUESTED",
      "cid": this.cid
    }

    this.isLoading = true
    this.generic_service.getAllObjectAllocationRegistersByWildSearchWithPagination(body).subscribe(
      (response: any) => {
        this.objectAllocationRegisterList = response.response.objectAllocationRegisterList
        this.count = response.response.totalRecords
        this.isLoading = false
      },
      (error: any) => {
        this.isLoading = false
        console.log(error)
      }
    )
  }

  getAllObjectAllocationRegisterWithPagination(pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "location": this.userLocations || [],
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage,
      "wildSearch": "",
      "userId": this.userCred.userId,
      "status": "REQUESTED",
      "cid": this.cid
    }

    this.isLoading = true
    this.generic_service.getAllObjectAllocationRegisterWithPagination(body).subscribe(
      (response: any) => {
        this.objectAllocationRegisterList = response.response.objectAllocationRegisterList
        this.count = response.response.totalRecords
        this.isLoading = false
      },
      (error: any) => {
        this.isLoading = false
        console.log(error)
      }
    )
  }


  getAllObjectAllocationRegister() {
    this.generic_service.getAllObjectAllocationRegister().subscribe(
      (response: any) => {
        console.log(response);
        // this.objectAllocationRegisterList = response.response
        // this.count = response.response.length
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  remove() {
    document.getElementById("closeModalButton")?.click()
    this.objectTemplateId = ""
    this.form.reset()
  }

  objectAllocationRegister() {


    if (this.formSubmit) {
      return
    }

    this.formSubmit = true;

    if (!this.form.valid) {
      this.formSubmit = false;
      this.toastr.error("please fill required fields");
      return
    }

    const selectedLocation = this.form.get('location')?.value
    const loc = this.locationList.find((list: any) => list.zone === selectedLocation);

    const template = this.objectTemplateList.find((list: any) => list.name === this.form.get('objectTemplateName')?.value);

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.form.get('description').value,
      "cid": Number(sessionStorage.getItem('cid')),
      "latestStatus": "REQUESTED",
      "status": [
        {
          "userId": this.userCred.userId,
          "issueStatus": "REQUESTED",
          "updatedDate": new Date().getTime(),
          "name": this.userCred.userName
        },
      ],
      "remarks": "",
      "returnedOn": "",
      "objectTemplateName": this.form.get('objectTemplateName')?.value,
      "requestedByUserId": this.userCred.userId,
      "requestedByUserName": this.userCred.userName,
      "requestedDate": new Date().toISOString().split('T')[0],
      "requestedQuantity": Number(this.form.get('requestedQuantity')?.value),
      "requestedUOM": this.isRequestedUOM ? this.form.get('requestedUOM')?.value : "",
      "approvedUserId": "",
      "approvedUserName": "",
      "approvedDate": "",
      "approvedQuantity": 0,
      "approvedUOM": "",
      "bulkObjects": [],
      "country": loc.country,
      "provinceOrState": loc.provinceOrState,
      "district": loc.district,
      "zone": loc.zone,
      "postalCode": loc.postalCode,
      "city": loc.city,
      "location": loc.zone,
      "available": true,
      "qty": template.quantity
    }



    console.log(body)
    this.generic_service.objectAllocationRegister(body).subscribe(
      (response: any) => {
        document.getElementById("closeModalButton")?.click()
        document.getElementById("closeModalButton1")?.click()
        this.toastr.success(response.message);
        this.formSubmit = false;
        this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)

      },
      (error: any) => {
        this.formSubmit = false;
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }


  selectDelete(id: any, list: any) {
    this.objectTemplateId = id;
    this.recordId = list.objectAllocationRegisterId
    this.recordName = list.objectTemplateName
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  refreshAll() {
    this.page = 0
    this.first = 0
    this.searchFilter = ""
    this.objectStatus = "ALL"
    this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)
  }

  getAllObjectAllocationRegistersByWildSearch() {
    console.log(this.searchFilter)
    if (this.searchFilter == "" || this.searchFilter == null) {
      return
    }
    this.generic_service.getAllObjectAllocationRegistersByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectAllocationRegisterList = []
          this.count = 0
          return

        }
        this.objectAllocationRegisterList = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }



  deleteObjectAllocationRegister() {
    this.generic_service.deleteObjectAllocationRegister(this.objectTemplateId).subscribe(
      (response: any) => {
        console.log(response);
        document.getElementById("closeModalDelete")?.click()
        this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)
        this.toastr.success(response.message)
        this.clearData()
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )
  }

  changeStatusClick() {
    this.isStatusUpdate = !this.isStatusUpdate
  }


  issuedClicked() {
    this.isApproveUpdate = false
    this.isReject = false
    this.remarks = ""
    this.approvedQuantity = ""
    this.issuedSelectedList = []
    this.issuedSelectedListWithDetail = []
    this.isIssued = !this.isIssued
    if (this.isIssued) {
      setTimeout(() => {
        this.focusScannerInput();
      }, 0);
    }
  }

  approveClick() {
    this.isReject = false
    this.isIssued = false
    this.remarks = ""
    this.approvedQuantity = ""
    this.isApproveUpdate = !this.isApproveUpdate
  }

  rejectClick() {
    this.isIssued = false
    this.isApproveUpdate = false
    this.remarks = ""
    this.approvedQuantity = ""
    this.isReject = !this.isReject
  }

  allocationStatusUpdate() {

    if (this.isStatusSubmited) {
      return
    }

    this.isStatusSubmited = true
    // let userId: any
    // for(let list of this.singleObjectAllocationRegisterData[0].status){
    //   if(list.issueStatus == "REQUESTED"){
    //     userId = list.userId
    //   }
    // }

    let body = {
      "userId": Number(sessionStorage.getItem('userId')),
      "issueStatus": this.singleObjectAllocationRegisterData[0].latestStatus,
      "updatedDate": new Date().getTime()
    }

    console.log(body)
    this.generic_service.updateStatusForAllocationRegister(this.singleObjectAllocationRegisterData[0].objectAllocationRegisterId, body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)
        this.isStatusUpdate = false
        this.issueStatus = ""
        this.isStatusSubmited = false
        this.getObjectAllocationRegisterById(this.singleObjectAllocationRegisterData[0].objectAllocationRegisterId)
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
        this.isStatusSubmited = false

      }
    )
  }

  updateAllocationStatus(latestStatus: any) {

    if (this.isStatusSubmited) {
      return
    }

    this.isStatusSubmited = true
    // let userId: any
    // for(let list of this.singleObjectAllocationRegisterData[0].status){
    //   if(list.issueStatus == "REQUESTED"){
    //     userId = list.userId
    //   }
    // }

    let body = {
      "userId": Number(sessionStorage.getItem('userId')),
      "issueStatus": latestStatus,
      "updatedDate": new Date().getTime(),
      "name": sessionStorage.getItem('userName'),
      "remarks": ""
    }

    console.log(body)
    this.generic_service.updateStatusForAllocationRegister(this.singleObjectAllocationRegisterData[0].objectAllocationRegisterId, body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)
        this.isStatusUpdate = false
        this.issueStatus = ""
        this.isStatusSubmited = false
        this.getObjectAllocationRegisterById(this.singleObjectAllocationRegisterData[0].objectAllocationRegisterId)
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
        this.isStatusSubmited = false

      }
    )
  }

  updateObjectAllocationRegisterForApproval() {

    if (this.approvedQuantity == 0) {
      this.toastr.error('Please enter quantity')
      return; // exit the function
    }

    if (this.approvedQuantity > this.singleObjectAllocationRegisterData[0].requestedQuantity) {
      // Optionally show a warning to the user
      this.toastr.error('Approved quantity cannot exceed requested quantity')
      return; // exit the function
    }

    const body = {
      "objectAllocationRegisterId": this.singleObjectAllocationRegisterData[0].objectAllocationRegisterId,
      "latestStatus": "APPROVED",
      "requestedByUserId": this.singleObjectAllocationRegisterData[0].requestedByUserId,
      "requestedByUserName": this.singleObjectAllocationRegisterData[0].requestedByUserName,
      "requestedDate": this.singleObjectAllocationRegisterData[0].requestedDate,
      "requestedQuantity": this.singleObjectAllocationRegisterData[0].requestedQuantity,
      "requestedUOM": this.singleObjectAllocationRegisterData[0].requestedUOM,
      "approvedUserId": Number(sessionStorage.getItem('userId')),
      "approvedUserName": sessionStorage.getItem('userName'),
      "approvedDate": new Date().toISOString().split('T')[0],
      "approvedQuantity": Number(this.approvedQuantity),
      "approvedUOM": this.singleObjectAllocationRegisterData[0].requestedUOM,
      "status": {
        "userId": Number(sessionStorage.getItem('userId')),
        "issueStatus": "APPROVED",
        "updatedDate": new Date().getTime(),
        "name": sessionStorage.getItem('userName'),
        "remarks": this.remarks
      },
      "remarks": this.remarks,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateObjectAllocationRegisterForApproval(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)
        this.approveClick()

        this.isApproveUpdate = false
        this.isIssued = false

        this.remarks = ""
        this.approvedQuantity = ""
        this.isApproveUpdate = false

        this.getObjectAllocationRegisterById(this.singleObjectAllocationRegisterData[0].objectAllocationRegisterId)
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)

      }
    )
  }

  updateObjectAllocationRegisterForIssue() {

    const data = this.singleObjectAllocationRegisterData[0];

    const approvedQty = data.approvedQuantity;
    const issuedQty = data.issuedQty || 0;

    // **Validate selection**
    if (!this.issuedSelectedList || this.issuedSelectedList.length === 0) {
      this.toastr.error("Please select an asset")
      return;
    }

    const newlyIssuedCount = this.issuedSelectedList.length;
    const finalIssuedTotal = issuedQty + newlyIssuedCount;

    // **Approved quantity validation**
    if ((!data.qty) && finalIssuedTotal > approvedQty) {
      this.toastr.error("Issue quantity cannot exceed approved quantity");
      return;
    } else {

      let qty = 0

      for (let list of this.issuedSelectedListWithDetail) {
        qty += Number(list.tobeIssuedQty)
      }
      if (qty + issuedQty > approvedQty) {
        console.log(this.issuedSelectedListWithDetail)
        this.toastr.error("Issue quantity cannot exceed approved quantity");
        return;
      }
      for (let list of this.issuedSelectedListWithDetail) {
        if (Number(list.tobeIssuedQty) > Number(list.availableQty)) {
          this.toastr.error("Asset quantity cannot exceed available quantity");
          return
        }
      }
    }

    // Existing or new bulkList
    // const bulkList: any[] = data.bulkObjects || [];
    let bulkList: any[] = [...(data.bulkObjects || [])];

    // Create map for object info lookup
    const objectInfoMap = new Map(
      this.objectInfoListByTemplateNameAndLocation.map((item: any) => [
        item.objectInfoId,
        item
      ])
    );

    const today = new Date().toISOString().split("T")[0];
    const userId = Number(sessionStorage.getItem("userId"));
    const userName = sessionStorage.getItem("userName");


    if (data.qty) {
      // Add newly issued items to bulkList

      bulkList = [];

      for (const selected of this.issuedSelectedListWithDetail) {
        const objectInfo: any = objectInfoMap.get(selected.objectInfoId);
        if (objectInfo) {
          bulkList.push({
            objectGivenName: objectInfo.givenName,
            objectId: objectInfo.objectInfoId,
            objectSerialNo: objectInfo.serialNumber,
            issuedDate: today,
            issuedByUserId: userId,
            issuedByUserName: userName,
            tobeIssuedQty: Number(selected.tobeIssuedQty) || 0,
            deployedQty: 0,
            latestStatus: "ISSUED",
            status: [
              {
                userId: userId,
                issueStatus: "ISSUED",
                updatedDate: new Date().getTime(),
                name: userName,
              }
            ],
            deploy: objectInfo.deploy,
            remarks: ""
          });
        }
      }
    } else {
      for (const selected of this.issuedSelectedList) {
        const objectInfo: any = objectInfoMap.get(selected.objectInfoId);
        if (objectInfo) {
          bulkList.push({
            objectGivenName: objectInfo.givenName,
            objectId: objectInfo.objectInfoId,
            objectSerialNo: objectInfo.serialNumber,
            issuedDate: today,
            issuedByUserId: userId,
            issuedByUserName: userName,
            tobeIssuedQty: 0,
            latestStatus: "ISSUED",
            status: [
              {
                userId: userId,
                issueStatus: "ISSUED",
                updatedDate: new Date().getTime(),
                name: userName,
              }
            ],
            deploy: objectInfo.deploy,
            remarks: ""
          });
        }
      }
    }





    // Create request body
    const body = {
      objectAllocationRegisterId: data.objectAllocationRegisterId,
      latestStatus: "ISSUED",
      bulkObjects: bulkList,
      status: {
        userId: userId,
        issueStatus: "ISSUED",
        updatedDate: new Date().getTime(),
        name: userName,
        remarks: this.remarks
      },
      remarks: "",
      cid: this.cid
    };

    console.log("API Body →", body);

    // Call the update API
    this.generic_service.updateObjectAllocationRegisterForIssue(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);

        this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)
        this.isApproveUpdate = false;
        this.isIssued = false;

        this.remarks = "";
        this.approvedQuantity = "";
        this.isApproveUpdate = false;



        this.getObjectAllocationRegisterById(data.objectAllocationRegisterId);
      },
      (error: any) => {
        this.toastr.error(error.error.errors?.[0]?.description || "Something went wrong");
        console.error(error);
      }
    );
  }



  updateObjectAllocationRegisterForIssue1() {



    const data = this.singleObjectAllocationRegisterData[0];

    const approvedQty = data.approvedQuantity;
    const requestedQty = data.requestedQuantity;
    const issuedQty = data.bulkObjects?.length || 0;

    let bulkList: any[] = data.bulkList || [];

    // Create a map for quick lookup
    const objectInfoMap = new Map(
      this.objectInfoListByTemplateNameAndLocation.map((item: any) => [
        item.objectInfoId,
        item
      ])
    );

    // Add newly issued items
    for (const selected of this.issuedSelectedList) {
      const objectInfo: any = objectInfoMap.get(selected.objectInfoId);
      if (objectInfo) {
        bulkList.push({
          objectGivenName: objectInfo.givenName,
          objectId: objectInfo.objectInfoId,
          objectSerialNo: objectInfo.serialNumber,
          issuedDate: new Date().toISOString().split('T')[0],
          issuedByUserId: Number(sessionStorage.getItem('userId')),
          issuedByUserName: sessionStorage.getItem('userName'),
          latestStatus: "ISSUED",
          status: [
            {
              userId: Number(sessionStorage.getItem('userId')),
              issueStatus: "ISSUED",
              updatedDate: Date.now(),
              name: sessionStorage.getItem('userName'),
            }
          ],
          deploy: objectInfo.deploy,
          remarks: ""
        });
      }
    }

    // No selected asset
    if (this.issuedSelectedList.length === 0) {
      this.toastr.error("Please select an asset");
      return;
    }

    // Quantity validation
    const newIssuedCount = this.issuedSelectedList.length;
    const finalIssuedTotal = issuedQty + newIssuedCount;

    if (finalIssuedTotal > approvedQty) {
      this.toastr.error("Issue quantity cannot exceed approved quantity");
      return;
    }

    // At this point bulkList has valid updated items
    console.log("Updated bulkList:", bulkList);



    const body = {
      "objectAllocationRegisterId": this.singleObjectAllocationRegisterData[0].objectAllocationRegisterId,
      "latestStatus": "ISSUED",
      "bulkObjects": bulkList,
      "status": {
        "userId": Number(sessionStorage.getItem('userId')),
        "issueStatus": "ISSUED",
        "updatedDate": new Date().getTime(),
        "name": sessionStorage.getItem('userName'),
        "remarks": this.remarks
      },
      "remarks": "",
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateObjectAllocationRegisterForIssue(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllObjectAllocationRegisterWithPagination(this.page, this.recordsPerPage)
        this.isApproveUpdate = false
        this.isIssued = false

        this.remarks = ""
        this.approvedQuantity = ""
        this.isApproveUpdate = false
        // for(let list of bulkList){
        //   this.updateObjectHolding(list.objectId)
        // }

        this.getObjectAllocationRegisterById(this.singleObjectAllocationRegisterData[0].objectAllocationRegisterId)
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)

      }
    )
  }


  updateObjectHolding(objectInfoId: any) {

    const body = {
      "objectInfoId": objectInfoId,
      "holding": {
        "allocationRegisterId": this.singleObjectAllocationRegisterData[0]?.objectAllocationRegisterId,
        "userId": 0,
        "name": "COMPANY",
        "date": new Date().getTime()
      },
      "cid": Number(sessionStorage.getItem('cid')),
    }
    console.log(body)
    this.generic_service.updateObjectHolding(body).subscribe(
      (response: any) => {
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  updateObjectHolding1(objectInfoId: any) {

    const body = {
      "objectInfoId": objectInfoId,
      "holding": {
        "allocationRegisterId": this.singleObjectAllocationRegisterData[0]?.objectAllocationRegisterId,
        "userId": Number(sessionStorage.getItem('userId')),
        "name": sessionStorage.getItem('userName'),
        "date": new Date().getTime()
      },
      "cid": Number(sessionStorage.getItem('cid')),
    }
    console.log(body)
    this.generic_service.updateObjectHolding(body).subscribe(
      (response: any) => {
        this.updateObjectHolding(objectInfoId)

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  statusChanged(event: any) {
    // Check if latestStatus is 'ISSUED'
    this.isIssued = event.target.value === 'ISSUED';
    if (this.isIssued) {
      setTimeout(() => {
        this.focusScannerInput();
      }, 0);
    }
  }


  onItemSelect(item: any) {

    const data = this.singleObjectAllocationRegisterData?.[0];
    if (!data) {
      return;
    }

    // qty is a boolean flag
    if (data.qty === true) {
      const approvedQty = Number(data.approvedQuantity) || 0;
      const issuedQty = Number(data.issuedQty) || 0;

      const selectedItem = this.objectInfoListByTemplateNameAndLocation
        ?.find((list: any) => String(list.objectInfoId) === String(item.objectInfoId));

      if (!selectedItem) {
        this.toastr.error('Selected item not found');
        return;
      }

      const newlyIssuedCount = Number(selectedItem.availableQty) || 0;
      const finalIssuedTotal = issuedQty + newlyIssuedCount;

      if (!this.issueSelection) {
        this.toastr.error('Issue quantity cannot exceed approved quantity');
        this.removeSelectedItem(item);
        return;
      }




      // ✅ Approved quantity validation
      if (finalIssuedTotal >= approvedQty) {
        this.issueSelection = false
        this.issuedSelectedListWithDetail.push({
          objectInfoId: item.objectInfoId,
          nameAndAvailableQty: item.nameAndAvailableQty,
          tobeIssuedQty: selectedItem.availableQty,
          availableQty: selectedItem.availableQty
        })
      } else {
        this.issueSelection = true
        this.issuedSelectedListWithDetail.push({
          objectInfoId: item.objectInfoId,
          nameAndAvailableQty: item.nameAndAvailableQty,
          tobeIssuedQty: selectedItem.availableQty
        })
      }



    } else {
      this.issuedSelectedListWithDetail.push(item)
    }
  }


  onSelectAll(items: any) {

  }

  removeSelectedItem(item: any) {
    this.issuedSelectedList = this.issuedSelectedList.filter(
      (u: any) => String(u.objectInfoId) !== String(item.objectInfoId)
    );
  }


  onItemDeSelect(item: any) {
    this.issuedSelectedList = this.issuedSelectedList.filter(
      (u: any) => String(u.objectInfoId) !== String(item.objectInfoId)
    );

    this.issuedSelectedListWithDetail = this.issuedSelectedListWithDetail.filter(
      (u: any) => String(u.objectInfoId) !== String(item.objectInfoId)
    );

    const data = this.singleObjectAllocationRegisterData?.[0];
    if (!data) {
      return;
    }

    // qty is a boolean flag
    if (data.qty === true) {
      const approvedQty = Number(data.approvedQuantity) || 0;
      const issuedQty = Number(data.issuedQty) || 0;

      const deselectedItem = this.objectInfoListByTemplateNameAndLocation
        ?.find((list: any) => String(list.objectInfoId) === String(item.objectInfoId));

      if (!deselectedItem) {
        return;
      }

      if (this.issuedSelectedList.length == 0) {
        this.issueSelection = true
        return
      }

      const releasedQty = Number(deselectedItem.availableQty) || 0;

      let selectedQty = 0;
      const objectInfoMap = new Map(
        this.objectInfoListByTemplateNameAndLocation.map((obj: any) => [
          String(obj.objectInfoId),
          obj
        ])
      );

      for (const selected of this.issuedSelectedList) {
        const objectInfo: any = objectInfoMap.get(String(selected.objectInfoId));
        if (objectInfo) {
          selectedQty += Number(objectInfo.availableQty) || 0;
        }
      }
      const finalIssuedTotal = issuedQty + selectedQty;

      if (finalIssuedTotal >= approvedQty) {
        this.issueSelection = false
      } else {
        this.issueSelection = true
      }
    }
  }



  updateObjectAllocationRegisterForObjectsOnceAtATime(latestStatus: any, asset: any) {

    const body = {
      "objectAllocationRegisterId": this.singleObjectAllocationRegisterData[0]?.objectAllocationRegisterId,
      "latestStatus": this.singleObjectAllocationRegisterData[0]?.latestStatus,
      "bulkObjects": {
        "objectGivenName": asset.objectGivenName,
        "objectId": asset.objectId,
        "objectSerialNo": asset.objectSerialNo,
        "issuedDate": asset.issuedDate,
        "issuedByUserId": asset.issuedByUserId,
        "issuedByUserName": asset.issuedByUserName,
        "latestStatus": latestStatus,
        "returnedQty": latestStatus === "RETURN_RECEIVED" ? asset.returnedQty : 0,
        "tobeIssuedQty": asset.tobeIssuedQty,
        "deployedQty": asset.deployedQty,
        "status": {
          "userId": Number(sessionStorage.getItem('userId')),
          "issueStatus": latestStatus,
          "updatedDate": new Date().getTime(),
          "name": sessionStorage.getItem('userName')
        },
        "remarks": "",
        "deploy": asset.deploy,

      },
      "remarks": this.singleObjectAllocationRegisterData[0]?.remarks,
      "cid": Number(sessionStorage.getItem('cid')),
    }
    console.log(body)
    this.generic_service.updateObjectAllocationRegisterForObjectsOnceAtATime(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.updateObjectHolding1(asset.objectId)
        this.getObjectAllocationRegisterById(this.singleObjectAllocationRegisterData[0]?.objectAllocationRegisterId)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )

  }


  getStatus(status: any) {
    return this.statusListInfo.find((c: any) => c.key === status)?.value || ' -- ';
  }



  focusScannerInput() {
    const input = document.getElementById('scanner-input');
    if (input) {
      input.focus();
    }
  }

  onScannerInput(event: any) {
    const value = event.target.value;
    event.target.value = ''; // clear input

    if (!value) return;

    try {
      const scannedData = JSON.parse(value);
      console.log(scannedData)
      const scannedId = scannedData.Id || scannedData.objectInfoId || scannedData.objectId;
      console.log(scannedId)

      if (!scannedId) {
        this.toastr.error('Invalid scanned data: No ID found');
        return;
      }

      this.processScannedId(scannedId);
    } catch (e) {
      // If not JSON, assume the raw value is the ID
      this.processScannedId(value);
    }
  }

  processScannedId(scannedId: any) {
    if (!this.objectInfoListByTemplateNameAndLocation || this.objectInfoListByTemplateNameAndLocation.length === 0) {
      this.toastr.error('No assets available to scan in this allocation.');
      return;
    }

    const matchedItem = this.objectInfoListByTemplateNameAndLocation.find(
      (item: any) => String(item.objectInfoId) === String(scannedId) || String(item.serialNumber) === String(scannedId)
    );

    if (!matchedItem) {
      this.toastr.error('Scanned asset not found in the current location or template');
      return;
    }

    // Check for duplicate
    const isAlreadySelected = this.issuedSelectedList.some(
      (item: any) => String(item.objectInfoId) === String(matchedItem.objectInfoId)
    );

    if (isAlreadySelected) {
      this.toastr.warning('Asset already selected');
      return;
    }

    // Update issuedSelectedList array
    this.issuedSelectedList = [...this.issuedSelectedList, matchedItem];

    // Trigger onItemSelect logic manually to handle detailed selection list and quantity logic
    this.onItemSelect(matchedItem);

    this.toastr.success(`Asset ${matchedItem.givenName} scanned and added`);
  }

  filterInputByType(event: KeyboardEvent, inputType: 'number' | 'onlyText' | 'allText'): boolean {
    const key = event.key;
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Always allow control keys (e.g., backspace, arrows, delete, tab, etc.)
    const controlKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Tab', 'Home', 'End'
    ];
    if (controlKeys.includes(key)) {
      return true;
    }

    if (key === 'Enter') {
      return true;
    }

    switch (inputType) {
      case 'number':
        // Allow digits only
        if (!/^\d$/.test(key)) {
          event.preventDefault();
          return false;
        }
        break;

      case 'onlyText':
        // Allow letters and space (not as first character)
        if (!/^[a-zA-Z ]$/.test(key) || (key === ' ' && currentValue.length === 0)) {
          event.preventDefault();
          return false;
        }
        break;

      case 'allText':
        // Allow all characters, but disallow space as first character
        if (key === ' ' && currentValue.length === 0) {
          event.preventDefault();
          return false;
        }
        break;

      default:
        event.preventDefault();
        return false;
    }

    return true;
  }

}